/*
 * @Author: Veto [关于活动部分 路由]
 * @Date: 2021-06-16 16:08:20 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2022-08-25 13:23:08
 */

import VIPMark from '../views/pages/vip/mark';
import VIPService from '../views/pages/vip/service';
import VIPBoons from '../views/pages/vip/boons';
import VIPFreemsg from '../views/pages/vip/freemsg';
import VIPFreevideo from '../views/pages/vip/freevideo';
import VIPNamecolor from '../views/pages/vip/namecolor';

import Contract from '../views/pages/vip/contract';
import GuideDesc from '../views/pages/guide/desc';
import AgreementUser from '../views/agreement/user';
import AgreementPay from '../views/agreement/pay';

import ErrorAccess from '../views/common/errorAccess.vue';


const router = {
    '/vip-mark': VIPMark,
    '/vip-service': VIPService,
    '/vip-boons': VIPBoons,
    '/vip-freemsg': VIPFreemsg,
    '/vip-freevideo': VIPFreevideo,
    '/vip-namecolor': VIPNamecolor,

    '/vip-contract': Contract,
    '/guide-desc': GuideDesc,
    // '/agreement-user': AgreementUser,
    '/agreement-user': ErrorAccess,
    // '/agreement-pay': AgreementPay,
    '/agreement-pay': ErrorAccess
};


export default router;